/* eslint-disable camelcase */
import TextInput from 'common/components/TextInput'
import { GAUniversalEvent } from 'lib/google-analytics'
import ChecklistCardV2 from 'services/Questionnaire/components/ChecklistCardV2'
import RadioBullet from 'services/Questionnaire/components/RadioBullet'
import RadioCard from 'services/Questionnaire/components/RadioCard'
import RadioDropdown from 'services/Questionnaire/components/RadioDropdown'
import GAEvent from 'services/Questionnaire/event/google-analytics'
import { useStoreActions, useStoreState } from 'stores/hooks'

function QuestionnaireWrapper({
  responsive = false,
}: {
  responsive?: boolean
}): JSX.Element {
  const {
    data: questionnaireList,
    selectedPage,
    answerList,
    errorList,
  } = useStoreState((state) => state.questionnaire)

  const {
    setAnswer,
    getMoreQuestionnaire,
    removeQuestion,
  } = useStoreActions((actions) => actions.questionnaire)

  const handleChange = (id, value) => {
    const indexAnswer = answerList.findIndex(
      (a) => a.question_id === id,
    )
    const indexQuestion = questionnaireList[
      selectedPage
    ]?.questions?.findIndex((q) => q.id === id)
    const question =
      questionnaireList[selectedPage]?.questions[indexQuestion]

    if (
      question?.answer_type !== 'checklist_card' &&
      GAEvent[question.question]
    ) {
      GAUniversalEvent(
        GAEvent[question.question].category,
        GAEvent[question.question].action.replace(
          '$var',
          value.option,
        ),
        GAEvent[question.question].label.replace(
          '$var',
          value.option,
        ),
      )
    }

    const newAnswer = [...answerList]
    if (indexAnswer >= 0) {
      newAnswer[indexAnswer] = {
        ...newAnswer[indexAnswer],
        question_id: id,
        answer: value?.id || value,
      }
    }
    if (
      newAnswer?.[indexAnswer]?.answer !==
      answerList?.[indexAnswer]?.answer
    ) {
      setAnswer(newAnswer)
      if (value?.next_questions) {
        getMoreQuestionnaire({
          url: value?.next_questions?.url,
          idReff: id,
        })
      } else {
        removeQuestion(id)
      }
    }
  }

  const getValue = (questionId) => {
    const answerIndex = answerList?.findIndex(
      (list) => list.question_id === questionId,
    )
    if (answerIndex >= 0) {
      return answerList[answerIndex]?.answer
    }
    return null
  }

  const getMaxMin = (validationRules, type) => {
    if (type === 'max') {
      const maxValue = validationRules?.find(
        (vr) => vr.name === 'max_character',
      )?.value
      if (maxValue) {
        return maxValue
      }
    } else {
      const minValue = validationRules?.find(
        (vr) => vr.name === 'min_character',
      )?.value
      if (minValue) {
        return minValue
      }
    }
    return ''
  }

  const handleChangeInput = (questionId, val, validationRules) => {
    const regex = validationRules?.find(
      (vr) => vr.name === 'regex_pattern',
    )?.value
    if (val && regex) {
      if (val?.match(regex)) {
        handleChange(questionId, val)
      }
    } else {
      handleChange(questionId, val)
    }
  }

  return (
    <>
      {questionnaireList?.[selectedPage]?.questions?.length > 0 &&
        questionnaireList?.[selectedPage]?.questions?.map(
          (question) => {
            if (question?.answer_type === 'radio_card') {
              return (
                <RadioCard
                  key={question.id}
                  options={question?.options}
                  onChange={(value) =>
                    handleChange(question?.id, value)
                  }
                  defaultValue={getValue(question.id)}
                  responsive={responsive}
                />
              )
            }
            if (question?.answer_type === 'radio_dropdown') {
              return (
                <RadioDropdown
                  key={question.id}
                  data={question}
                  error={errorList.includes(question.id)}
                  onChange={(id, value) => {
                    handleChange(id, value)
                  }}
                  defaultValue={getValue(question.id)}
                />
              )
            }
            if (question?.answer_type === 'checklist_card') {
              return (
                <ChecklistCardV2
                  key={question.id}
                  data={question}
                  onChange={(id, value) => {
                    handleChange(id, value)
                  }}
                  defaultValue={getValue(question.id)}
                />
              )
            }
            if (question?.answer_type === 'radio_bullet') {
              return (
                <RadioBullet
                  key={question.id}
                  data={question}
                  onChange={(value) => {
                    handleChange(question?.id, value)
                  }}
                  defaultValue={getValue(question.id)}
                />
              )
            }
            return (
              <TextInput
                key={question.id}
                height="50px"
                fontSize="14px"
                onChange={(e) =>
                  handleChangeInput(
                    question?.id,
                    e.target.value,
                    question?.validation_rules,
                  )
                }
                maxLength={getMaxMin(
                  question?.validation_rules,
                  'max',
                )}
                minLength={getMaxMin(
                  question?.validation_rules,
                  'min',
                )}
                placeholder={question.question}
                value={getValue(question.id)}
              />
            )
          },
        )}
    </>
  )
}

export default QuestionnaireWrapper
